<app-spinner></app-spinner>
<form [formGroup]="maintenanceForm">
	<div class="grid grid-cols-12 gap-2">
		<!-- First column, spans 5 columns -->
		<div class="col-span-12 md:col-span-5">
			<div class="bg-white dark:bg-gray-600 shadow-md rounded-lg">
				<div class="p-4">
					<div class="grid grid-cols-12">
						<div class="col-span-12">
							<h6 class="text-md font-semibold dark:text-white">
								RMS Module Control
							</h6>
						</div>
					</div>
					<div class="grid grid-cols-12">
						<div class="col-span-12">
							<h6 class="text-md font-semibold dark:text-white">
								<b>&sect;1</b> - Date Selection Fields
							</h6>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.1</b> First Payroll Start
										Date</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="First Payroll Start Date" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="FirstPayrollStartDate" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!--<div class="relative flex-1">
										 <input
											type="text"
											id="FirstPayrollStartDate"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="FirstPayrollStartDate"
											readonly
											(click)="openPayrollStartCalendar()"
										/>
										@if (
											maintenanceForm.get(
												'FirstPayrollStartDate'
											)?.value
										) {
											<button
												type="button"
												(click)="
													clearFirstPayrollStartDate()
												"
												class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
												title="Clear date"
											>
												<svg
													xmlns="http://www.w3.org/2000/svg"
													fill="none"
													viewBox="0 0 24 24"
													stroke-width="2"
													stroke="currentColor"
													class="w-3 h-3"
												>
													<path
														stroke-linecap="round"
														stroke-linejoin="round"
														d="M6 18L18 6M6 6l12 12"
													/>
												</svg>
											</button>
										}
									</div>
									<button
										type="button"
										(click)="openPayrollStartCalendar()"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button>-->
								</div>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.2</b> Time Card Locked After
										Date</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Locks Time Card Input after a specified date"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="AfterDate" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!-- <div class="relative flex-1">
										<input
											type="text"
											id="AfterDate"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="AfterDate"
											readonly
											(click)="openAfterDateCalendar()"
										/>
										<button
											type="button"
											*ngIf="
												maintenanceForm.get('AfterDate')
													?.value
											"
											(click)="clearAfterDate()"
											class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
											title="Clear date"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												class="w-3 h-3"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									</div>
									<button
										type="button"
										(click)="openAfterDateCalendar()"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button> -->
								</div>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.3</b> Inventory Locked After
										Date</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Locks inputting Inventory on Time Cards after a specified date"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="InventoryLockedAfterDate" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!-- <div class="relative flex-1">
										<input
											type="text"
											id="InventoryLockedAfterDate"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="InventoryLockedAfterDate"
											readonly
											(click)="
												openInventoryLockedAfterDateCalendar()
											"
										/>
										<button
											type="button"
											*ngIf="
												maintenanceForm.get(
													'InventoryLockedAfterDate'
												)?.value
											"
											(click)="
												clearInventoryLockedAfterDate()
											"
											class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
											title="Clear date"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												class="w-3 h-3"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									</div>
									<button
										type="button"
										(click)="
											openInventoryLockedAfterDateCalendar()
										"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button> -->
								</div>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.4</b> Benefits Locked After
										Date</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Locks inputting benefit Time Cards after a specified date"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="BenefitsLockedAfterDate" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!-- <div class="relative flex-1">
										<input
											type="text"
											id="BenefitsLockedAfterDate"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="BenefitsLockedAfterDate"
											readonly
											(click)="
												openBenefitsLockedAfterDateCalendar()
											"
										/>
										<button
											type="button"
											*ngIf="
												maintenanceForm.get(
													'BenefitsLockedAfterDate'
												)?.value
											"
											(click)="
												clearBenefitsLockedAfterDate()
											"
											class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
											title="Clear date"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												class="w-3 h-3"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									</div>
									<button
										type="button"
										(click)="
											openBenefitsLockedAfterDateCalendar()
										"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button> -->
								</div>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.5</b> Daily Training Notification
										Run Time</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Daily Training Notification Run Time" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="DailyNotificationRunDateTime" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!-- <div class="relative flex-1">
										<input
											type="text"
											id="DailyNotificationRunDateTime"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="DailyNotificationRunDateTime"
											readonly
											(click)="
												openDailyNotificationRunDateTimeCalendar()
											"
										/>
										<button
											type="button"
											*ngIf="
												maintenanceForm.get(
													'DailyNotificationRunDateTime'
												)?.value
											"
											(click)="
												clearDailyNotificationRunDateTime()
											"
											class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
											title="Clear date"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												class="w-3 h-3"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									</div>
									<button
										type="button"
										(click)="
											openDailyNotificationRunDateTimeCalendar()
										"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button> -->
								</div>
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="input"><b>1.6</b> Weekly Training Notification
										Run Date/Time</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Weekly Training Notification Run Date/Time"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<div class="flex items-center">
									<datepicker formControlName="WeeklyNotificationRunDateTime" dateFormat="mm/dd/yyyy"
										placeHolder="Select date...">
									</datepicker>
									<!-- <div class="relative flex-1">
										<input
											type="text"
											id="WeeklyNotificationRunDateTime"
											placeholder="Select date..."
											class="bg-white w-full duration-200 border border-[#E2E2E2] py-2 pl-4 pr-10 rounded-l-lg border-r-0 dark:bg-gray-700 dark:border-gray-500 dark:text-white"
											formControlName="WeeklyNotificationRunDateTime"
											readonly
											(click)="
												openWeeklyNotificationRunDateTimeCalendar()
											"
										/>
										<button
											type="button"
											*ngIf="
												maintenanceForm.get(
													'WeeklyNotificationRunDateTime'
												)?.value
											"
											(click)="
												clearWeeklyNotificationRunDateTime()
											"
											class="absolute right-2 top-1/2 transform -translate-y-1/2 w-6 h-6 rounded-full bg-gray-200 text-gray-600 flex items-center justify-center hover:bg-red-500 hover:text-white dark:bg-gray-500 dark:text-white dark:hover:bg-red-500 duration-200"
											title="Clear date"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="2"
												stroke="currentColor"
												class="w-3 h-3"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="M6 18L18 6M6 6l12 12"
												/>
											</svg>
										</button>
									</div>
									<button
										type="button"
										(click)="
											openWeeklyNotificationRunDateTimeCalendar()
										"
										class="py-2 px-3 space-x-1 rounded-r-lg border border-[#E2E2E2] border-l-0 text-[16px] bg-white text-gray-600 flex items-center dark:text-white dark:bg-gray-700 duration-200 dark:border-gray-500"
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											class="w-6 h-6"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
											/>
										</svg>
									</button> -->
								</div>
							</div>
						</div>
					</div>

					<div class="grid grid-cols-12 mt-2">
						<div class="col-span-12">
							<h6 class="text-md dark:text-white font-semibold">
								<b>&sect;2</b> - Text Inputs
							</h6>
						</div>
					</div>

					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="Message"><b>2.1</b> Time Card Locked After Date
										Message</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="This is the message that will show up if any user tries to input time cards will time card entry is disabled unilaterally."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="Message" formControlName="Message"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Message" required />
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="InventoryLockedMessage"><b>2.2</b> Inventory Locked
										Message</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Inventory Locked Message" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="InventoryLockedMessage" formControlName="InventoryLockedMessage"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Inventory Locked Message" required />
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="BenefitsLockedMessage"><b>2.3</b> Benefits Locked
										Message</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Benefits Locked Message" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="BenefitsLockedMessage" formControlName="BenefitsLockedMessage"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="BenefitsLockedMessage" required />
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="RegularPayTypeAlias"><b>2.4</b> Regular Pay Type
										Alias</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="If you use a non-standard designation like 'RG', simply type that in."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="RegularPayTypeAlias" formControlName="RegularPayTypeAlias"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Regular Pay Type Alias" required />
							</div>
						</div>
					</div>

					<div class="grid grid-cols-12 mt-2">
						<div class="col-span-12">
							<h6 class="text-md dark:text-white font-semibold">
								<b>&sect;3</b> - Numerical Inputs
							</h6>
						</div>
					</div>

					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="EmployeeLogOff"><b>3.1</b> Employee LogOff</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Being idle for X amount of minutes, will automatically log off the user. '0' means the feature is disabled."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="EmployeeLogOff" formControlName="EmployeeLogOff"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Employee LogOff" required />
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="SupervisorLogOff"><b>3.2</b> Supervisor LogOff</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Being idle for X amount of minutes, will automatically log off the supervisor. '0' means the feature is disabled."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="SupervisorLogOff" formControlName="SupervisorLogOff"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Supervisor LogOff" required />
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="CalendarYears"><b>3.3</b> Calendar Years</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0" matTooltip="Calendar Years"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="CalendarYears" formControlName="CalendarYears"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Calendar Years" required />
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="ResetPasswordDays"><b>3.4</b> Reset Password Days</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="The number of days that pass before a user will be required to update their password.  '0' means the feature is disabled."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="ResetPasswordDays" formControlName="ResetPasswordDays"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Reset Password Days" required />
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4 mt-4">
						<div class="col-span-12">
							<div class="space-y-1">
								<!-- Label with Icon -->
								<label for="TrainingAdminEmpId"
									class="flex items-center justify-between text-sm whitespace-nowrap w-full">
									<span><b>3.5</b>&nbsp;Global Training
										Admin</span>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Select the users that you want to have full access to RMS Training (Certification/Education) Module"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</label>

								<!-- Dropdown -->
								<div class="flex-grow">
									<app-select-checkbox [options]="employeeList" placeholder="Choose an option"
										formControlName="TrainingAdminEmpId" [minWidth]="'120px'"></app-select-checkbox>
								</div>
							</div>
						</div>
					</div>
					<div class="col-span-12 md:col-span-6">
						<div class="space-y-1">
							<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
								<label for="GLLookUpEmployeeList"><b>3.6</b> Data Explorer Available Employee
									List</label>
								<span class="text-yellow-500 ml-auto flex-shrink-0" matTooltip="Data Explorer Available Employee
									List" matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<app-select-checkbox [options]="employeeList" placeholder="Choose an option"
								formControlName="GLLookUpEmployeeList" [minWidth]="'120px'"></app-select-checkbox>
						</div>
					</div>

					<div class="grid grid-cols-12 mt-2">
						<div class="col-span-12">
							<h6 class="text-md dark:text-white font-semibold">
								<b>&sect;4</b> - Toggles
							</h6>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="GLDepartment" type="checkbox" formControlName="GLDepartment" (change)="
										onCheckboxChange('GLDepartment', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="GLDepartment"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.1</b> GL
									Department<span class="info-icon text-yellow-500" matTooltip="GL Department"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="ShowAttachments" type="checkbox" formControlName="ShowAttachments" (change)="
										onCheckboxChange(
											'ShowAttachments',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="ShowAttachments"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.2</b> Show
									Equipment Attachments<span class="info-icon text-yellow-500"
										matTooltip="Show equipment attachments during Time Card entry"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="ShowAdditionalHourlyRateApplies" type="checkbox"
									formControlName="ShowAdditionalHourlyRateApplies" (change)="
										onCheckboxChange(
											'ShowAdditionalHourlyRateApplies',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="ShowAdditionalHourlyRateApplies"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.3</b> Show
									Additional Hourly Rate
									Applies<span class="info-icon text-yellow-500"
										matTooltip="Show Additional Hourly Rate Applies" matTooltipPosition="after"><svg
											xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="TimeClock" type="checkbox" formControlName="TimeClock" (change)="
										onCheckboxChange('TimeClock', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="TimeClock"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.4</b> Enable
									Time Clock<span class="info-icon text-yellow-500"
										matTooltip="Allow the company as a whole to have the potential to access to utilize Time Clock punches"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="TimeClockDecimal" type="checkbox" formControlName="TimeClockDecimal"
									(change)="
										onCheckboxChange(
											'TimeClockDecimal',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="TimeClockDecimal"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.5</b> Time
									Clock - Format as
									Decimal<span class="info-icon text-yellow-500"
										matTooltip="(Exclusively for Time Clock Reporting) When on, it will convert the time card punches from HH:MM:SS format to a Decimal format (to the thousandths)"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="Inventory" type="checkbox" formControlName="Inventory" (change)="
										onCheckboxChange('Inventory', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="Inventory"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.6</b>
									Inventory<span class="info-icon text-yellow-500" matTooltip="Inventory"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="InventoryReleaseApproval" type="checkbox"
									formControlName="InventoryReleaseApproval" (change)="
										onCheckboxChange(
											'InventoryReleaseApproval',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="InventoryReleaseApproval"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.7</b>
									Inventory Release Approval<span class="info-icon text-yellow-500"
										matTooltip="Inventory Release Approval" matTooltipPosition="after"><svg
											xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="TimeClockDecimalTenths" type="checkbox"
									formControlName="TimeClockDecimalTenths" (change)="
										onCheckboxChange(
											'TimeClockDecimalTenths',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="TimeClockDecimalTenths"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.8</b> Time
									Clock - Decimal Rounded to
									Tenths<span class="info-icon text-yellow-500"
										matTooltip="(Exclusively for Time Clock Reporting) When on, it will convert the time card punches from HH:xxx format to a Decimal format that's rounded to the tenths position (HH:x)."
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<input type="hidden" class="form-input" name="APIKey" ng-model="ModuleControlMaster.APIKey"
								autocomplete="off" />

							<div class="flex items-center">
								<input id="AllowChangePassword" type="checkbox" formControlName="AllowChangePassword"
									(change)="
										onCheckboxChange(
											'AllowChangePassword',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="AllowChangePassword"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.9</b> Allow
									Users to Change Their RMS
									Password<span class="info-icon text-yellow-500"
										matTooltip="Give individuals the ability to update their own passwords"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="SecondApproval" type="checkbox" formControlName="SecondApproval" (change)="
										onCheckboxChange(
											'SecondApproval',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="SecondApproval"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.10</b> Add
									Reviewers to TC Approval
									Process<span class="info-icon text-yellow-500"
										matTooltip="Declare individuals to review time card entries prior to a supervisor's approval."
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>

					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="ComplexPassword" type="checkbox" formControlName="ComplexPassword" (change)="
										onCheckboxChange(
											'ComplexPassword',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="ComplexPassword"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.11</b>
									Require Complex Password<span class="info-icon text-yellow-500"
										matTooltip="This adds the requirements to include at least 8 characters, with at least one of each of the following: uppercase, lowercase, number, and special character."
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="AdditionalRate" type="checkbox" formControlName="AdditionalRate" (change)="
										onCheckboxChange(
											'AdditionalRate',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="AdditionalRate"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.12</b>
									Additional Rate<span class="info-icon text-yellow-500"
										matTooltip="Records an associated additional hourly rate on the Time Card Header based off the associated Job Classification"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="AdditionalRateRequested" type="checkbox"
									formControlName="AdditionalRateRequested" (change)="
										onCheckboxChange(
											'AdditionalRateRequested',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="AdditionalRateRequested"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.13</b>
									Additional Rate Requested by
									User<span class="info-icon text-yellow-500"
										matTooltip="Allows a button to show up on the labor hours entry page that will enable the user to request an additional hourly rate themselves"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="useLocationServices" type="checkbox" formControlName="useLocationServices"
									(change)="
										onCheckboxChange(
											'useLocationServices',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="useLocationServices"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.14</b>
									Capture GPS Coordinates<span class="info-icon text-yellow-500"
										matTooltip="This will requires users to grant access to the browser to log their whereabouts (primarily for clocking in and out)."
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="useCombinedPayTypeEntry" type="checkbox"
									formControlName="useCombinedPayTypeEntry" (change)="
										onCheckboxChange(
											'useCombinedPayTypeEntry',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="useCombinedPayTypeEntry"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.15</b> Use
									Combined Pay Type
									Entry<span class="info-icon text-yellow-500"
										matTooltip="Allow users to input split time in one screen with the same pay type (reg and OT at once)"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsTraining" type="checkbox" formControlName="IsTraining" (change)="
										onCheckboxChange('IsTraining', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsTraining"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.16</b> Enable
									Training Module<span class="info-icon text-yellow-500"
										matTooltip="Enables RMS' Training (Certification/Education) Module."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsDailyNotification" type="checkbox" formControlName="IsDailyNotification"
									(change)="
										onCheckboxChange(
											'IsDailyNotification',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsDailyNotification"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.17</b>
									Training: Enable Daily
									Notification Emails<span class="info-icon text-yellow-500"
										matTooltip="Daily Emails regarding Training/Certification info"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsWeeklyNotification" type="checkbox" formControlName="IsWeeklyNotification"
									(change)="
										onCheckboxChange(
											'IsWeeklyNotification',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsWeeklyNotification"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.18</b>
									Training: Enable Weekly
									Notifications Emails<span class="info-icon text-yellow-500"
										matTooltip="Weekly Emails regarding Training/Certification info"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="CopyDetailsDefaultEquipCheck" type="checkbox"
									formControlName="CopyDetailsDefaultEquipCheck" (change)="
										onCheckboxChange(
											'CopyDetailsDefaultEquipCheck',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="CopyDetailsDefaultEquipCheck"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.19</b> Copy
									Details - Default 'Copy
									Equipment' ON<span class="info-icon text-yellow-500"
										matTooltip="When copying time card Details - Default 'Copy Equipment' to ON"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="CopyDetailsDefaultInvCheck" type="checkbox"
									formControlName="CopyDetailsDefaultInvCheck" (change)="
										onCheckboxChange(
											'CopyDetailsDefaultInvCheck',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="CopyDetailsDefaultInvCheck"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.20</b> Copy
									Details - Default 'Copy
									Inventory' ON<span class="info-icon text-yellow-500"
										matTooltip="When copying time card Details - Default 'Copy Inventory' to ON"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
						</div>
					</div>

					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="CityworksIntegration" type="checkbox" formControlName="Cityworks" (change)="
										onCheckboxChange('Cityworks', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="CityworksIntegration"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.21</b> Enable
									Cityworks
									Integration<span class="info-icon text-yellow-500"
										matTooltip="Enables you to connect Time Card Entries to Cityworks"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<!-- @if (maintenanceForm.get('Cityworks')?.value) { -->
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="CityworksAPIKey"><b>4.22</b> Cityworks API Key</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0" matTooltip="Cityworks API Key"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="CityworksAPIKey" formControlName="CityworksAPIKEY"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="Cityworks API Key" required [readonly]="
										!maintenanceForm.get('Cityworks')?.value
									" />
							</div>
						</div>
						<!-- } -->
					</div>

					<div class="grid grid-cols-12 items-center gap-4">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center opacity-50 pointer-events-none select-none">
								<input id="PTOIntegration" type="checkbox" formControlName="IsPTO"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 dark:bg-gray-700 dark:border-gray-600"
									[checked]="true" />
								<label for="PTOIntegration"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">
									<b>4.23</b> PTO Integration<span class="info-icon text-yellow-500"
										matTooltip="PTO Integration" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75
									 4.365 9.75 9.75-4.365 9.75-9.75
									 9.75S2.25 17.385 2.25 12Zm8.706-1.442
									 c1.146-.573 2.437.463 2.126
									 1.706l-.709 2.836.042-.02a.75.75
									 0 0 1 .67 1.34l-.04.022c-1.147.573
									 -2.438-.463-2.127-1.706l.71-2.836
									 -.042.02a.75.75 0 1 1-.671-1.34
									 l.041-.022ZM12 9a.75.75 0 1 0
									 0-1.5.75.75 0 0 0 0 1.5Z" clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
					</div>

					<div class="grid grid-cols-12 items-center gap-4 mt-2">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsReviewBulkAction" type="checkbox" formControlName="IsReviewBulkAction"
									(change)="
										onCheckboxChange(
											'IsReviewBulkAction',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsReviewBulkAction"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>4.24</b> Enable
									Review Entries Bulk
									Action<span class="info-icon text-yellow-500"
										matTooltip="Enable Review Entries Bulk Action" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>

						<div class="col-span-12 md:col-span-6">
							<div class="flex-col items-center">
								<!-- Label with Icon -->
								<label for="CityworksAdminUserList"
									class="flex items-center justify-between text-sm whitespace-nowrap w-full">
									<span><b>4.25</b>&nbsp;Cityworks Admin
										Access</span>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="The Cityworks Admin tab appears only if the cityworks integration flag is turned ON and a valid employee is selected from the dropdown."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</label>

								<!-- Dropdown -->
								<div class="flex-grow">
									<app-select-checkbox [options]="employeeList" placeholder="Choose user(s)"
										formControlName="CityworksAdminUserList"
										[minWidth]="'120px'"></app-select-checkbox>
								</div>
							</div>
							<!-- <div class="flex items-center">
								<input
									id="CityworksAdminUserList"
									type="checkbox"
									formControlName="CityworksAdminUserList"
									(change)="
										onCheckboxChange(
											'CityworksAdminUserList',
											$event
										)
									"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
								/>
								<label
									for="CityworksAdminUserList"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
									><b>4.25</b> Cityworks Admin Access List<span
										class="info-icon text-yellow-500"
										matTooltip="Cityworks Admin Access"
										matTooltipPosition="after"
									>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="currentColor"
										class="w-4 h-4"
									>
										<path
											fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd"
										/>
									</svg>
								</span></label>
							</div> -->
						</div>

						<!-- <div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input
									id="GLLookUpEmployeeList"
									type="checkbox"
									formControlName="GLLookUpEmployeeList"
									(change)="
										onCheckboxChange(
											'GLLookUpEmployeeList',
											$event
										)
									"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
								/>
								<label
									for="GLLookUpEmployeeList"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
									><b>4.24</b> GL Look Up Available Employee List<span
										class="info-icon text-yellow-500"
										matTooltip="GL Look Up Available Employee List"
										matTooltipPosition="after"
									>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="currentColor"
										class="w-4 h-4"
									>
										<path
											fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd"
										/>
									</svg>
								</span></label>
							</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<!-- Second column, spans 5 columns -->
		<div class="col-span-12 md:col-span-5">
			<div class="bg-white dark:bg-gray-600 shadow-md rounded-lg">
				<div class="p-4">
					<div class="grid grid-cols-12">
						<div class="col-span-12">
							<h6 class="text-md dark:text-white font-semibold">
								<b>&sect;5</b> - Time Card Settings
							</h6>
						</div>
					</div>
					<div class="grid gap-3 mb-6 md:grid-cols-2">
						<div>
							<div class="flex gap-1 items-center text-sm mt-2">
								<label for="LaborWarningHours"><b>5.1</b> Labor Warning Hours</label>
								<span class="text-yellow-500" matTooltip="Labor Warning Hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<input type="text" id="LaborWarningHours" formControlName="LaborWarningHours"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="Labor Warning Hours" />
						</div>
						<div>
							<div class="flex gap-1 items-center text-sm mt-2">
								<label for="EquipmentMaxHours"><b>5.2</b> Equipment Max Hours</label>
								<span class="text-yellow-500" matTooltip="Equipment Max Hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<input type="text" id="EquipmentMaxHours" formControlName="EquipmentMaxHours"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="Equipment Max Hours" />
						</div>

						<div class="flex items-center">
							<input id="IsLaborHoursWarning" type="checkbox" formControlName="IsLaborHoursWarning"
								(change)="
									onCheckboxChange(
										'IsLaborHoursWarning',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsLaborHoursWarning"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.3</b> Labor Hours
								Warning when the daily
								expected threshold is met<span class="info-icon text-yellow-500"
									matTooltip="Labor Hours Warning when the daily expected threshold is met"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsLaborUpdateEquipmentHoursWarning" type="checkbox"
								formControlName="IsLaborUpdateEquipmentHoursWarning" (change)="
									onCheckboxChange(
										'IsLaborUpdateEquipmentHoursWarning',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsLaborUpdateEquipmentHoursWarning"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.4</b> When Labor
								Hours are Updated, a
								Reminder to update Equipment Hours<span class="info-icon text-yellow-500"
									matTooltip="When Labor Hours are Updated, a Reminder to update Equipment Hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEquipmentMaxHoursWarning" type="checkbox"
								formControlName="IsEquipmentMaxHoursWarning" (change)="
									onCheckboxChange(
										'IsEquipmentMaxHoursWarning',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEquipmentMaxHoursWarning"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.5</b> Set a
								ceiling on the number of daily
								equipment hours<span class="info-icon text-yellow-500"
									matTooltip="Set a ceiling on the number of daily equipment hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEquipmentandLaborHoursWarning" type="checkbox"
								formControlName="IsEquipmentandLaborHoursWarning" (change)="
									onCheckboxChange(
										'IsEquipmentandLaborHoursWarning',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEquipmentandLaborHoursWarning"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.6</b> Reminder
								that Equipment and Labor
								Hours should equal<span class="info-icon text-yellow-500"
									matTooltip="Reminder that Equipment and Labor Hours should equal"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsAllowReviewersSubmit" type="checkbox" formControlName="IsAllowReviewersSubmit"
								(change)="
									onCheckboxChange(
										'IsAllowReviewersSubmit',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsAllowReviewersSubmit"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.7</b> Enable
								Reviewers to Submit<span class="info-icon text-yellow-500"
									matTooltip="Enable Reviewers to Submit" matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEquipmentNotLaborHoursWarning" type="checkbox"
								formControlName="IsEquipmentNotLaborHoursWarning" (change)="
									onCheckboxChange(
										'IsEquipmentNotLaborHoursWarning',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEquipmentNotLaborHoursWarning"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.8</b> When
								Equipment Hours are updated, a
								reminder to update Labor Hours<span class="info-icon text-yellow-500"
									matTooltip="When Equipment Hours are updated, a reminder to update Labor Hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="LoginScreenShowAll" type="checkbox" formControlName="LoginScreenShowAll"
								(change)="
									onCheckboxChange(
										'LoginScreenShowAll',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="LoginScreenShowAll"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.9</b> Show
								Clock-in/Out option to everyone
								(regardless if they can)<span class="info-icon text-yellow-500"
									matTooltip="Show Clock-in/Out option to everyone (regardless if they can)"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsLogDuplicateTokens" type="checkbox" formControlName="IsLogDuplicateTokens"
								(change)="
									onCheckboxChange(
										'IsLogDuplicateTokens',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsLogDuplicateTokens"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.10</b> Log
								Concurrent Employee RMS
								Sessions<span class="info-icon text-yellow-500"
									matTooltip="Log Concurrent Employee RMS Sessions" matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="ConcurrentLogin" type="checkbox" formControlName="ConcurrentLogin" (change)="
									onCheckboxChange('ConcurrentLogin', $event)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="ConcurrentLogin"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.11</b> Prohibit
								Concurrent RMS Employee
								Sessions by employee<span class="info-icon text-yellow-500"
									matTooltip="Prohibit Concurrent RMS Employee Sessions by employee"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsSequenceIncrements" type="checkbox" formControlName="IsSequenceIncrements"
								(change)="
									onCheckboxChange(
										'IsSequenceIncrements',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsSequenceIncrements"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.12</b> Require
								Labor Hours to be entered
								in quarter-hour increments<span class="info-icon text-yellow-500"
									matTooltip="Require Labor Hours to be entered in quarter-hour increments"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEmpSummaryJoClassificationToggle" type="checkbox"
								formControlName="IsEmpSummaryJoClassificationToggle" (change)="
									onCheckboxChange(
										'IsEmpSummaryJoClassificationToggle',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEmpSummaryJoClassificationToggle"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.13</b> Review
								Entry - Emp Summary-Default
								'Show Job Classification' on<span class="info-icon text-yellow-500"
									matTooltip="Review Entry - Emp Summary-Default 'Show Job Classification' on"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEmpSummaryExpandAllToggle" type="checkbox"
								formControlName="IsEmpSummaryExpandAllToggle" (change)="
									onCheckboxChange(
										'IsEmpSummaryExpandAllToggle',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEmpSummaryExpandAllToggle"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.14</b> Review
								Entry -Emp Summary-Default
								'Expand All' on<span class="info-icon text-yellow-500"
									matTooltip="Review Entry -Emp Summary-Default 'Expand All' on"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsEmpSummaryTrimGLToggle" type="checkbox"
								formControlName="IsEmpSummaryTrimGLToggle" (change)="
									onCheckboxChange(
										'IsEmpSummaryTrimGLToggle',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsEmpSummaryTrimGLToggle"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.15</b> Review
								Entry -Emp Summary-Default
								'Trim GL' on<span class="info-icon text-yellow-500"
									matTooltip="Review Entry -Emp Summary-Default 'Trim GL' on"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsConsecutiveLoginFailedLock" type="checkbox"
								formControlName="IsConsecutiveLoginFailedLock" (change)="
									onCheckboxChange(
										'IsConsecutiveLoginFailedLock',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsConsecutiveLoginFailedLock"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.16</b> RMS Login
								- Brute Force Entry
								Deterrent<span class="info-icon text-yellow-500"
									matTooltip="Temporarily Disable RMS Login after 5 consecutive failed attempts for 15 minutes"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div>
							<div class="flex gap-1 items-center text-sm mt-2">
								<label for="Lock Email Address"><b>5.17</b> Temporary Lock-Out Alert email
									recipients</label>

								<span class="text-yellow-500" matTooltip="Temporary Lock-Out Alert email recipients"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<input type="text" id="LockEMailAddress" formControlName="LockEMailAddress"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="Email Address" required />
						</div>
						<div class="flex items-center">
							<input id="IsReviewShowTimecard" type="checkbox" formControlName="IsReviewShowTimecard"
								(change)="
									onCheckboxChange(
										'IsReviewShowTimecard',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsReviewShowTimecard"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.18</b> Review
								Entry - Show All Time Clock
								Punches easily<span class="info-icon text-yellow-500"
									matTooltip="Review Entry - Show All Time Clock Punches easily"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div class="flex items-center">
							<input id="IsMinimumThresholdAlerts" type="checkbox"
								formControlName="IsMinimumThresholdAlerts" (change)="
									onCheckboxChange(
										'IsMinimumThresholdAlerts',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsMinimumThresholdAlerts"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.19</b> Daily RMS
								notifications for
								previously unfulfilled expected Labor
								entries<span class="info-icon text-yellow-500"
									matTooltip="Daily RMS notifications for previously unfulfilled expected Labor entries"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
						<div>
							<div class="flex gap-1 items-center text-sm mt-2">
								<label for="TimeCardLockEmployeeList"><b>5.20</b> Lock TimeCard Entry for
									Employees</label>
								<span class="text-yellow-500" matTooltip="Lock TimeCard Entry for Employees"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<input type="text" id="TimeCardLockEmployeeList" formControlName="TimeCardLockEmployeeList"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="ex: 123, 456" />
						</div>
						<div>
							<div class="text-sm mt-2">
								<label for="CopyDetailsNotAllowPayTypes"><b>5.21</b> Disable 'Copy Details'
									functionality on certain pay types<span class="info-icon text-yellow-500"
										matTooltip="Disable 'Copy Details' functionality on certain pay types"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
							<input type="text" id="CopyDetailsNotAllowPayTypes"
								formControlName="CopyDetailsNotAllowPayTypes"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="ex: VacBuyBack" />
						</div>

						<div class="flex items-center">
							<input id="AllowZeroLaborHours" type="checkbox" formControlName="AllowZeroLaborHours"
								(change)="
									onCheckboxChange(
										'AllowZeroLaborHours',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="AllowZeroLaborHours"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.22</b> Allow Zero
								Labor Hours<span class="info-icon text-yellow-500" matTooltip="Allow Zero Labor Hours"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
					</div>

					<div class="flex items-center">
						<div>
							<div class="flex items-center gap-1 mb-2">
								<label class="text-sm font-medium text-gray-900 dark:text-gray-300">
									<b>5.23</b> Select Work Week Days
								</label>
								<span class="text-yellow-500" matTooltip="Select Work Week Days"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>

							<div class="flex flex-wrap items-center gap-x-4 gap-y-1">
								@for (day of weekdays; track day.value) {
								<div class="inline-flex items-center gap-1">
									<label class="inline-flex items-center gap-1 cursor-pointer">
										<input type="checkbox" [(ngModel)]="day.checked" [ngModelOptions]="{
													standalone: true
												}" class="rounded text-blue-500 focus:ring-blue-400 h-4 w-4" />
										{{ day.name }}
									</label>
									<!-- <button
											type="button"
											(click)="
												openPaytypeWeekdayDialog(day)
											"
											class="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400 cursor-pointer"
											matTooltip="Add a Pay Type (Limited by Day)"
											matTooltipPosition="above"
										>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												fill="none"
												viewBox="0 0 24 24"
												stroke-width="1.5"
												stroke="currentColor"
												class="size-5"
											>
												<path
													stroke-linecap="round"
													stroke-linejoin="round"
													d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
												/>
											</svg>
										</button> -->
								</div>
								}
							</div>
						</div>
					</div>

					<div class="flex items-center">
						<div>
							<!-- Label and info icon in single line -->
							<div class="flex items-center gap-1 my-3">
								<label class="text-sm font-medium text-gray-900 dark:text-gray-300">
									<b>5.24</b> Daily labor union notification
								</label>
								<span class="text-yellow-500" matTooltip="Daily labor union notification"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>

							<!-- Weekdays checkboxes in a row below -->
							<div class="flex flex-wrap items-center gap-x-4 gap-y-1">
								<app-select-checkbox [options]="employeeUnionUnits"
									[formControlName]="'NotificationUnionUnits'" [enableSearch]="true"
									[minWidth]="'175px'" [dropPosition]="'top'"></app-select-checkbox>
							</div>
						</div>
					</div>

					<!-- Control Inventory and PO Menu -->
					<div class="grid grid-cols-12 items-center gap-4 mt-2">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsItemMaster" type="checkbox" formControlName="IsItemMaster" (change)="
										onCheckboxChange('IsItemMaster', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsItemMaster"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.25</b> Nav
									Menu - Enable Item
									Master<span class="info-icon text-yellow-500"
										matTooltip="Nav Menu - Enable Item Master" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsInventory" type="checkbox" formControlName="IsInventory" (change)="
										onCheckboxChange('IsInventory', $event)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsInventory"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.26</b> Nav
									Menu - Enable
									Inventory<span class="info-icon text-yellow-500"
										matTooltip="Nav Menu - Enable Inventory" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="IsPurchaseOrder" type="checkbox" formControlName="IsPurchaseOrder" (change)="
										onCheckboxChange(
											'IsPurchaseOrder',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsPurchaseOrder"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.27</b> Nav
									Menu - Enable Purchase
									Order<span class="info-icon text-yellow-500"
										matTooltip="Nav Menu - Enable Purchase Order" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>

						<!-- <div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input
									id="PayHoursRestrictedMultiple"
									type="checkbox"
									formControlName="PayHoursRestrictedMultiple"
									(change)="
										onCheckboxChange(
											'PayHoursRestrictedMultiple',
											$event
										)
									"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
								/>
								<label
									for="PayHoursRestrictedMultiple"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
									><b>5.28</b> Conflicting Pay Types<span
										class="info-icon text-yellow-500"
										matTooltip="PayHours Restricted Multiple"
										matTooltipPosition="after"
									>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										viewBox="0 0 24 24"
										fill="currentColor"
										class="w-4 h-4"
									>
										<path
											fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd"
										/>
									</svg>
								</span></label>
							</div>
						</div> -->
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="ConflictingPayTypes"><b>5.28</b> Conflicting Pay
										Types</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0"
										matTooltip="Conflicting Pay Types" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<app-select-checkbox [options]="allPaytypes" placeholder="Select Pay types"
									[formControlName]="'ConflictingPayTypes'" [minWidth]="'120px'" [enableSearch]="true"
									[dropPosition]="'top'"></app-select-checkbox>
							</div>
						</div>
					</div>

					<div class="col-span-12 md:col-span-6">
						<div class="space-y-1">
							<div class="flex gap-1 items-center text-sm mt-2">
								<label for="PayHoursRestrictedValues"><b>5.29</b> Usage pay type
									increments</label>
								<span class="text-yellow-500" matTooltip="Usage pay type increments"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>
							<input-dropdown class="w-full" [options]="restrictedPayTypes" [enableInputFields]="true"
								[inputPlaceholder]="'Value'" [inputType]="'number'" [inputWidth]="'90px'"
								[formControlName]="'PayHoursRestrictedValues'" [enableSearch]="true"
								[dropPosition]="'top'"></input-dropdown>
						</div>
					</div>

					<div class="flex items-center">
						<div>
							<div class="flex items-center gap-1 mb-2 mt-2">
								<label class="text-sm font-medium text-gray-900 dark:text-gray-300">
									<b>5.30</b> Select Day-Restricted Pay Type
								</label>
								<span class="text-yellow-500" matTooltip="Select Day-Restricted Pay Type"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg>
								</span>
							</div>

							<div class="flex flex-wrap items-center gap-x-4 gap-y-1">
								@for (day of weekdays; track day.value) {
								<div class="inline-flex items-center gap-1">
									<label class="inline-flex items-center gap-1 cursor-pointer">
										<!-- <input
												type="checkbox"
												[(ngModel)]="day.checked"
												[ngModelOptions]="{
													standalone: true
												}"
												class="rounded text-blue-500 focus:ring-blue-400 h-4 w-4"
											/> -->
										{{ day.name }}
									</label>
									<button type="button" (click)="
												openPaytypeWeekdayDialog(day)
											" class="text-yellow-500 hover:text-yellow-600 dark:hover:text-yellow-400 cursor-pointer"
										matTooltip="Select pay types that are allowed only on specific days as per system settings."
										matTooltipPosition="above">
										<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
											stroke-width="1.5" stroke="currentColor" class="size-5">
											<path stroke-linecap="round" stroke-linejoin="round"
												d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
										</svg>
									</button>
								</div>
								}
							</div>
						</div>
					</div>

					<div class="flex items-center gap-2 mt-2">
						<div>
							<div class="flex items-center">
								<input id="IsInsufficientClockedInTimeIndicator" type="checkbox"
									formControlName="IsInsufficientClockedInTimeIndicator" (change)="
										onCheckboxChange(
											'IsInsufficientClockedInTimeIndicator',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsInsufficientClockedInTimeIndicator"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.31</b>
									Insufficient Clocked In Time
									Indicator<span class="info-icon text-yellow-500"
										matTooltip="Insufficient Clocked In Time Indicator" matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div>
							<div class="text-sm mt-2">
								<label for="InsufficientClockedInTimeIndicatorThreshold"><b>5.32</b> Insufficient
									Clocked In Time
									Indicator Threshold<span class="info-icon text-yellow-500"
										matTooltip="Insufficient Clocked In Time Indicator Threshold (ex: 0.97) for 97%"
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
							<input type="text" id="InsufficientClockedInTimeIndicatorThreshold"
								formControlName="InsufficientClockedInTimeIndicatorThreshold"
								class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
								placeholder="(ex: 0.97) for 97%" required />
						</div>
					</div>

					<div class="flex items-center gap-2 mt-2">
						<div>
							<div class="flex items-center">
								<input id="IsDefaultShiftUnEditable" type="checkbox"
									formControlName="IsDefaultShiftUnEditable" (change)="
										onCheckboxChange(
											'IsDefaultShiftUnEditable',
											$event
										)
									" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="IsDefaultShiftUnEditable"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.33</b>
									Disable ability to change from
									default shift<span class="info-icon text-yellow-500"
										matTooltip="When enabled, it makes the default Shift un-editable from the Time Card entry process"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="flex items-center">
							<input id="IsShowHomeBenefitBalances" type="checkbox"
								formControlName="IsShowHomeBenefitBalances" (change)="
									onCheckboxChange(
										'IsShowHomeBenefitBalances',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsShowHomeBenefitBalances"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.34</b> Show
								Benefit Balances on Home
								Page<span class="info-icon text-yellow-500"
									matTooltip="When enabled, displays available benefit balances (Comp Earned, ESTA, Sick, Vacation) at the bottom of the Home page"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
					</div>
					<div class="flex items-center gap-2 mt-2">
						<div class="flex items-center">
							<input id="IsShowReviewBenefitBalances" type="checkbox"
								formControlName="IsShowReviewBenefitBalances" (change)="
									onCheckboxChange(
										'IsShowReviewBenefitBalances',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsShowReviewBenefitBalances"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.35</b> Show
								Benefit Balances on Review
								Entries Page<span class="info-icon text-yellow-500"
									matTooltip="When enabled, displays available benefit balances (Comp Earned, ESTA, Sick, Vacation) at the bottom of the Review Entries page"
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
					</div>

					<div class="flex items-center gap-2 mt-2">
						<div>
							<div class="flex items-center opacity-50 pointer-events-none select-none">
								<input id="W2ReportEnabled" type="checkbox" formControlName="W2ReportEnabled"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-0 dark:bg-gray-700 dark:border-gray-600" />
								<label for="W2ReportEnabled"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.36</b> Enable
									W-2 Report Access<span class="info-icon text-yellow-500"
										matTooltip="When enabled, authorized users will have access to the W-2 report within RMS. When disabled, the W-2 report will not be visible or accessible."
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="flex-1">
							<div class="text-sm mt-2">
								<label for="W2PrivilegedEmployeeList"><b>5.37</b> W-2 Report Admin<span
										class="info-icon text-yellow-500"
										matTooltip="Selected employees can access W-2 reports for all employees. Non-selected employees can access only their own W-2 forms only."
										matTooltipPosition="after"><svg xmlns="http://www.w3.org/2000/svg"
											viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg></span></label>
							</div>
							<app-select-checkbox [options]="w2PrivilegedEmployees" placeholder="Select Pay types"
								[formControlName]="'W2PrivilegedEmployeeList'" [minWidth]="'120px'"
								[enableSearch]="true" [dropPosition]="'top'"></app-select-checkbox>
						</div>
					</div>
					<div class="flex items-center gap-2 mt-2">
						<div class="flex items-center">
							<input id="IsActivity517flow" type="checkbox" formControlName="IsActivity517flow"
								(change)="
									onCheckboxChange(
										'IsActivity517flow',
										$event
									)
								" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
							<label for="IsActivity517flow"
								class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.38</b> Enable Dynamic Activity 517 State validation for mixed Job Categories<span class="info-icon text-yellow-500"
									matTooltip="Enabling this feature will dynamically restrict the projects and subsequent functions available for selection when a custom job classification is constructed that mixes additional activities alongside activity 517. 517 selections will only render state-related options and non 517 selections will render regular projects/functions."
									matTooltipPosition="after">
									<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
										class="w-4 h-4">
										<path fill-rule="evenodd"
											d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
											clip-rule="evenodd" />
									</svg> </span></label>
						</div>
					</div>
					<div class="grid grid-cols-12 items-center gap-4 mt-2">
						<div class="col-span-12 md:col-span-6">
							<div class="flex items-center">
								<input id="VUEWorksAPIIntegration" type="checkbox" formControlName="IsVUEWorksAPIEnabled"
									(change)="
										onCheckboxChange('IsVUEWorksAPIEnabled', $event)
									"
									class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
								<label for="VUEWorksAPIIntegration"
									class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"><b>5.39</b> Enable
									VUEWorks API<span class="info-icon text-yellow-500"
										matTooltip="Enables VUEWorks API integration"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg> </span></label>
							</div>
						</div>
						<div class="col-span-12 md:col-span-6">
							<div class="space-y-1">
								<div class="flex gap-1 items-center justify-between text-sm mt-2 w-full">
									<label for="VUEWorksAPIUrl"><b>5.40</b> VUEWorks API Key</label>
									<span class="text-yellow-500 ml-auto flex-shrink-0" matTooltip="VUEWorks API key used to authenticate external requests"
										matTooltipPosition="after">
										<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
											class="w-4 h-4">
											<path fill-rule="evenodd"
												d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
												clip-rule="evenodd" />
										</svg>
									</span>
								</div>
								<input type="text" id="VUEWorksAPIUrl" formControlName="VUEWorksAPIUrl"
									class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 placeholder-gray-500 dark:placeholder-gray-500"
									placeholder="VUEWorks API Key" [readonly]="
										!maintenanceForm.get('IsVUEWorksAPIEnabled')?.value
									" />
							</div>
						</div>
					</div>
					<input type="hidden" class="form-input" name="W2AllowAnyTaxYear" ng-model="W2AllowAnyTaxYear"
						autocomplete="off" />


				</div>
			</div>
		</div>

		<!-- Third column, spans 2 columns -->
		<div class="col-span-12 md:col-span-2">
			<div class="bg-white dark:bg-gray-600 shadow-md rounded-lg">
				<div class="p-4">
					<div class="grid grid-cols-12">
						<div class="col-span-12">
							<div class="flex justify-between">
								<h6 class="text-md dark:text-white font-semibold">
									Holidays Observed
								</h6>
								<a href="javascript:void(0);" (click)="addHolidays()" class="text-[#001f66]"
									[matTooltip]="'Add Holidays'">
									<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
										stroke-width="1.5" stroke="currentColor" class="size-5">
										<path stroke-linecap="round" stroke-linejoin="round"
											d="M12 4.5v15m7.5-7.5h-15" />
									</svg>
								</a>
							</div>

							<div class="table-container mt-2">
								<div class="relative overflow-x-auto shadow-md sm:rounded-lg">
									<table
										class="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
										<thead
											class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
											<tr>
												<th scope="col" class="px-6 py-3">
													Name
												</th>
												<th scope="col" class="px-6 py-3">
													Date
												</th>
												<th scope="col" class="px-6 py-3">
													Pay Types
												</th>
												<th scope="col" class="px-6 py-3">
													<span class="sr-only">Action</span>
												</th>
											</tr>
										</thead>
										<tbody>
											@for (
											item of holidaysList;
											track $index
											) {
											<tr
												class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
												<td class="px-6 py-4">
													{{ item.HolidayName }}
												</td>
												<td class="px-6 py-4">
													{{
													item.HolidayDate
													| date
													: 'MM/dd/yyyy'
													}}
												</td>
												<td class="px-6 py-4">
													@if (item.PayType) {
													<div class="relative inline-flex items-center justify-center cursor-pointer"
														[matTooltip]="
																	getPayTypesTooltip(
																		item.PayType
																	)
																" matTooltipPosition="above" matTooltipClass="custom-tooltip">
														<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
															fill="currentColor" class="w-5 h-5 text-green-500">
															<path fill-rule="evenodd"
																d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
																clip-rule="evenodd" />
														</svg>
													</div>
													} @else {
													<span class="text-gray-400">-</span>
													}
												</td>
												<td class="px-6 py-4 text-right">
													<div class="flex gap-2">
														<button (click)="
																	onUpdateHoliday(
																		item
																	)
																" class="font-medium text-[#d96e02] dark:text-[#d96e02] hover:underline">
															<svg xmlns="http://www.w3.org/2000/svg" fill="none"
																viewBox="0 0 24 24" stroke-width="1.5"
																stroke="currentColor" class="size-4">
																<path stroke-linecap="round" stroke-linejoin="round"
																	d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
															</svg>
														</button>
														<button (click)="
																	deleteHoliday(
																		item.HolidayId
																	)
																" class="font-medium text-[#dc3545] dark:text-[#dc3545] hover:underline">
															<svg xmlns="http://www.w3.org/2000/svg" fill="none"
																viewBox="0 0 24 24" stroke-width="1.5"
																stroke="currentColor" class="size-4">
																<path stroke-linecap="round" stroke-linejoin="round"
																	d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
															</svg>
														</button>
													</div>
												</td>
											</tr>
											}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</form>